module.exports = __webpack_public_path__ + "img/icon-04.0e10528c.png";